/**
 * Custom element that wraps the announcement bar and handles dismiss-to-session behaviour.
 * Falls back to in-memory flag when sessionStorage is unavailable.
 */
class AnnouncementBarDismiss extends HTMLElement {
  /** @type {boolean} */
  #dismissed = false;

  connectedCallback() {
    const key = this.dataset.storageKey || 'announcement-bar-dismissed';

    try {
      if (sessionStorage.getItem(key)) {
        this.hidden = true;
        return;
      }
    } catch (_) {
      if (this.#dismissed) {
        this.hidden = true;
        return;
      }
    }

    const btn = this.querySelector('[data-dismiss-announcement]');
    btn?.addEventListener('click', () => {
      this.hidden = true;
      try {
        sessionStorage.setItem(key, '1');
      } catch (_) {
        this.#dismissed = true;
      }
    });
  }
}

if (!customElements.get('announcement-bar-dismiss')) {
  customElements.define('announcement-bar-dismiss', AnnouncementBarDismiss);
}
